import React from "react";
import "./DiscountTag.css";
import classnames from "classnames";

const DiscountTag = ({
  discountAmount,
  discountType = "percent",
  className,
  side = "left",
  isRounded = false,
}: {
  discountAmount: string | number;
  discountType?: string;
  className: string;
  side?: string;
  isRounded: boolean;
}) => {
  const onLeft = side === "left" || !side;

  return (
    <div className={`absolute flex ${className}`}>
      {!onLeft && (
        <div className="discount-tag--triangle-right inline-block border-pickup" />
      )}
      <div
        className={classnames(
          "discount-tag bg-pickup text-white text-xs p-xs inline-block font-bold",
          {
            "rounded-tl": isRounded && onLeft,
            "rounded-tr": isRounded && !onLeft,
          }
        )}
      >
        {discountType === "percent"
          ? `${discountAmount}% off`
          : `$${discountAmount} off`}
      </div>
      {onLeft && (
        <div className="discount-tag--triangle-left inline-block border-pickup" />
      )}
    </div>
  );
};

export default DiscountTag;
